/* @flow */
import Button from 'components/Button.jsx';
import GroupClusterItem from 'entities/GroupClusterItem';
import GroupClusterItems from 'collections/GroupClusterItems';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import * as React from 'react';

import './styles/GroupAvatarCluster.scss';

function renderAvatarImage(avatarSvgUrl) {
  return <Image src={avatarSvgUrl} className="GroupAvatarCluster-avatar" />;
}

type Props = {
  groups: GroupClusterItems,
  maxSize: number,
  moreButtonHref?: string,
  onGroupAvatarClick?: Function,
};

class GroupAvatarCluster extends React.Component<Props> {
  renderAvatar = (group: GroupClusterItem, index: number) => {
    const { avatarSvgUrl } = group;
    if (!avatarSvgUrl) {
      console.error('GroupAvatarCluster missing avatarSvgUrl');
      return null;
    }

    if (this.props.onGroupAvatarClick) {
      return (
        <Link
          key={index}
          onClick={this.props.onGroupAvatarClick}
          className="GroupAvatarCluster-link"
          eventElementName="GroupAvatarCluster-link">
          {renderAvatarImage(avatarSvgUrl)}
        </Link>
      );
    } else {
      return <span key={index}>{renderAvatarImage(avatarSvgUrl)}</span>;
    }
  };

  renderMoreButton = (countNotShown: number) => {
    const bareButton = (
      <Button
        className="GroupAvatarCluster-more"
        level="secondary"
        shape="circle"
        eventElementName="GroupAvatarCluster-more">
        +{countNotShown}
      </Button>
    );

    if (this.props.moreButtonHref) {
      return (
        <Link
          href={this.props.moreButtonHref}
          className="GroupAvatarCluster-link"
          eventElementName="GroupAvatarCluster-link">
          {bareButton}
        </Link>
      );
    } else {
      return bareButton;
    }
  };

  render() {
    const allFit = this.props.groups.length === this.props.maxSize;
    const countToShow = allFit ? this.props.maxSize : this.props.maxSize - 1;
    const groupsToShow = this.props.groups.slice(0, countToShow);
    const countNotShown = this.props.groups.length - countToShow;

    return (
      <div className="GroupAvatarCluster">
        {groupsToShow.map(this.renderAvatar)}
        {countNotShown > 0 && this.renderMoreButton(countNotShown)}
      </div>
    );
  }
}

export default GroupAvatarCluster;
